"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SupportingDocumentModal = void 0;
const ramda_1 = require("ramda");
const core_1 = require("@material-ui/core");
const modal_1 = require("client/components/modal");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const button_1 = require("client/components/material/button");
const site_1 = require("shared/site");
const styles = core_1.createStyles({
    container: {},
    entry: {
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between"
    },
    entryButton: {
        display: "flex",
        justifyContent: "flex-end"
    },
    entryLabel: {
        display: "flex",
        padding: "5px 0"
    },
    entryLabelFrom: {},
    entryLabelKey: {
        fontWeight: "bold",
        marginRight: "10px"
    },
    entryLabelTo: {
        color: "green"
    },
    groupBox: {
        "&:nth-child(odd)": {
            background: "#f2f2f2"
        },
        "padding": "10px"
    },
    groupContainer: {
        marginBottom: "20px",
        marginLeft: "20px"
    },
    groupDocuments: {},
    groupFields: {
        marginBottom: "10px"
    },
    groupsContainer: {
        border: "#8080801c 1px solid",
        marginTop: "20px"
    }
});
const decorate = core_1.withStyles(styles);
let SupportingDocumentModalUnstyled = class SupportingDocumentModalUnstyled extends React.Component {
    constructor() {
        super(...arguments);
        this.renderEntry = (fromToArray) => {
            const { classes } = this.props;
            return fromToArray.map(fromTo => {
                const [key, fromToValues] = fromTo;
                const { from, to } = fromToValues;
                return (React.createElement("div", { key: key, className: classes.entry },
                    React.createElement("div", { className: classes.entryLabel },
                        React.createElement(core_1.Typography, { className: classes.entryLabelKey },
                            key,
                            ": "),
                        React.createElement(core_1.Typography, null,
                            React.createElement("span", { className: classes.entryLabelFrom }, from),
                            " --> ",
                            React.createElement("span", { className: classes.entryLabelTo }, to)))));
            });
        };
    }
    render() {
        const { fromTos, classes, supportingDocumentGroup } = this.props;
        const fromToGroups = ramda_1.groupBy(ft => ft[1].group, fromTos);
        return (React.createElement(modal_1.Modal, { onCancel: this.props.handleCancel, width: "600px", height: "600px", title: "Pharmacy Update Request", buttons: this.props.buttons ? this.props.buttons : [] },
            React.createElement("div", null,
                React.createElement(core_1.Typography, { variant: "title", gutterBottom: true }, "Update pharmacy supporting documents"),
                React.createElement(core_1.Typography, { variant: "subheading", gutterBottom: true }, "Attach supporting documents for the change requested if applicable."),
                React.createElement("div", { className: classes.groupsContainer }, Object.entries(fromToGroups)
                    .sort(a => {
                    if (a[0] === site_1.FieldGroup.Authorized) {
                        return -1;
                    }
                    return 0;
                })
                    .map(fromToGroup => {
                    const [groupName, fromToArray] = fromToGroup;
                    const supportingDocuments = supportingDocumentGroup
                        ? supportingDocumentGroup[groupName]
                        : [];
                    return (React.createElement("div", { className: classes.groupBox, key: groupName },
                        React.createElement("div", null,
                            fromToArray.length > 1 ? (React.createElement(core_1.Typography, { variant: "subheading" }, groupName === site_1.FieldGroup.Authorized
                                ? "Authorized To Edit"
                                : groupName)) : null,
                            React.createElement("div", { className: classes.groupContainer },
                                React.createElement("div", { className: classes.groupFields }, this.renderEntry(fromToArray)),
                                groupName !== site_1.FieldGroup.Authorized &&
                                    supportingDocuments &&
                                    supportingDocuments.length ? (React.createElement("div", { className: classes.groupDocuments },
                                    React.createElement(core_1.Typography, { variant: "subheading" }, "Supporting Documents Attached"),
                                    supportingDocuments.map((sd, index) => (React.createElement(core_1.Typography, { key: `${sd.name}${index}`, variant: "caption" }, sd.name))))) : null)),
                        React.createElement("div", { className: classes.entryButton }, groupName !== site_1.FieldGroup.Authorized ? (React.createElement(button_1.MaterialButton, { secondary: true, onClick: this.props.handleAttachDoc(groupName) }, "Attach Supporting Doc")) : ("No supporting documents required."))));
                })))));
    }
};
SupportingDocumentModalUnstyled = __decorate([
    mobx_react_1.observer
], SupportingDocumentModalUnstyled);
exports.SupportingDocumentModal = decorate(SupportingDocumentModalUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-site/components/supporting-document-modal/supporting-document-modal.tsx
// module id = 4020
// module chunks = 0